import { pwaInstallHandler } from 'pwa-install-handler';
import { useCallback, useSyncExternalStore } from 'react';

var usePWAInstall = function () {
    var subscribe = useCallback(function (onStoreChange) {
        pwaInstallHandler.addListener(onStoreChange);
        return function () {
            pwaInstallHandler.removeListener(onStoreChange);
        };
    }, []);
    var getSnapshot = useCallback(function () { return (pwaInstallHandler.canInstall() ? pwaInstallHandler.install : null); }, []);
    var getServerSnapshot = useCallback(function () { return null; }, []);
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};

export { usePWAInstall };
//# sourceMappingURL=index.es.js.map
